<template>
    <div id="wrapper" class="position-relative w-100 overflow-hidden">
        <main id="main" class="py-60">
            <div class="container">
                <div class="box-shadow pt-30 pb-40">
                    <div class="row justify-content-center my-30">
                        <div class="col-12">
                            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                                <form v-on:submit.prevent="handleSubmit(registerPhone)"
                                      class="main-form needs-validation">
                                    <ValidationProvider name="Phone" rules="required|phoneRestriction"
                                                        v-slot="{ errors }">

                                        <h4 class="text-light-blue mb-2">
                                            Enter your phone
                                        </h4>
                                        <input v-model="form.phone" type="text" class="form-control"
                                               placeholder="Enter your phone number" aria-label="passenger phone"
                                               v-mask="'(###) ###-####'">

                                        <div class="invalid-feedback">{{errors[0]}}</div>

                                        <div v-if="serverErrors" class="font-italic mt-20 invalid-feedback">
                                            {{ serverErrors }}
                                        </div>
                                    </ValidationProvider>

                                    <div class="mt-20 text-center">
                                        <button class="btn btn-primary px-40" type="submit">Send</button>
                                    </div>
                                </form>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        mounted() {
            this.form.hash = this.$route.params.hash;

            if (!this.form.hash) {
                this.homeRedirection()
            }
        },
        data() {
            return {
                form: {
                    hash: null,
                    phone: '',
                },
                serverErrors: null,
            };
        },
        methods: {
            homeRedirection() {
                this.$router.push({name: "Home"});
            },
            registerPhone() {
                this.serverErrors = null;

                axios.post("api/enter-phone", this.form)
                    .then(() => {
                        this.$swal({
                            title: 'Thank you!',
                            icon: 'success',
                            text: "Your phone number has been updated successfully"
                        }).then(() => {
                            this.homeRedirection()
                        })
                    })
                    .catch((err) => {
                        this.serverErrors = err.data.response.message;
                    });
            }
        }
    };
</script>

<style>
    .invalid-feedback {
        display: block;
    }

    .form-control {
        text-transform: none;
    }
</style>
